import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HolderInventory } from "@/components/inventory/HolderInventory";
import { TechHeader } from "@/pages/tech/TechHome";

export default function TechInventory() {
  return (
    <>
    <TechHeader />
    <div className="mx-auto max-w-2xl px-4 py-5" data-testid="tech-inventory-page">
      <Link to="/tecnico" className="mb-3 inline-flex items-center text-sm text-muted-foreground" data-testid="tech-inventory-back"><ArrowLeft className="mr-1 h-4 w-4" />Mis órdenes</Link>
      <h1 className="mb-1 font-display text-2xl font-bold">Mi inventario</h1>
      <p className="mb-4 text-xs text-muted-foreground">Equipos y materiales bajo tu responsabilidad. Puedes preparar un GPS con una SIM que también tengas asignada, devolver artículos al almacén o transferirlos a otro técnico (la transferencia aplica cuando él la acepta).</p>
      <HolderInventory userId="me" />
    </div>
    </>
  );
}
